import React from 'react';

/**
 * Typographic building blocks shared by the legal policy pages, so every
 * section of a long policy renders with the same rhythm.
 */
export function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <section className="mt-14" data-id="element-669" data-mp="3k4952h0g0xrz">
      <h2 className="text-2xl sm:text-3xl font-bold text-navy mb-6 tracking-tight" data-id="element-670" data-mp="3o7ozr7syco21">
        {title}
      </h2>
      <div className="space-y-4" data-id="element-671" data-mp="2ri7v8w5ph81x">{children}</div>
    </section>;
}
export function NumberedSection({
  id,
  number,
  title,
  children
}: {
  id: string;
  number: number;
  title: string;
  children: React.ReactNode;
}) {
  return <section id={id} className="mt-16 pt-10 border-t border-gray-200 scroll-mt-24" data-id="element-672" data-mp="30gtektj04r3r">
      <div className="flex items-baseline gap-3 mb-6" data-id="element-673" data-mp="35anwbrf1qw07">
        <span className="text-crimson font-bold text-xl" data-id="element-674" data-mp="28rq9xcn7deql">{number}.</span>
        <h2 className="text-2xl sm:text-3xl font-bold text-navy tracking-tight leading-tight" data-id="element-675" data-mp="28pdp8rq28q9u">
          {title}
        </h2>
      </div>
      <div className="space-y-5 leading-relaxed text-gray-700 text-base" data-id="element-676" data-mp="5beqrypgjwgf">
        {children}
      </div>
    </section>;
}
export function SubHeading({
  id,
  children
}: {
  id?: string;
  children: React.ReactNode;
}) {
  return <h3 id={id} className="text-lg font-bold text-navy mt-8 mb-3 scroll-mt-24" data-id="element-677" data-mp="3rovf1poxpd81">
      {children}
    </h3>;
}
export function Paragraph({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="text-gray-700 leading-relaxed" data-id="element-678" data-mp="3hu3eqe3ywc9k">{children}</p>;
}
export function BulletList({
  items
}: {
  items: React.ReactNode[];
}) {
  return <ul className="list-disc pl-6 space-y-2 marker:text-crimson" data-id="element-679" data-mp="38rlsw0s85ln3">
      {items.map((item, i) => <li key={i} className="text-gray-700 leading-relaxed" data-id="element-680" data-mp="33t0t22gvx3z6" data-mpi={i}>
          {item}
        </li>)}
    </ul>;
}

/** A bolded lead-in followed by its explanation, for rights and definitions. */
export function Term({
  label,
  children
}: {
  label: string;
  children: React.ReactNode;
}) {
  return <>
      <strong className="text-navy" data-id="element-681" data-mp="2whcmz3eih6w2">{label}.</strong> {children}
    </>;
}
export function SummaryItem({
  label,
  text
}: {
  label: string;
  text: string;
}) {
  return <div className="border-l-2 border-crimson/40 pl-4 py-1" data-id="element-682" data-mp="2mjge6i91qo14">
      <p className="text-gray-700 leading-relaxed" data-id="element-683" data-mp="2mkzuu9ym713f">
        <strong className="text-navy block mb-1" data-id="element-684" data-mp="2ri9ra9kf8d0r">{label}</strong>
        {text}
      </p>
    </div>;
}
export const policyLinkClass = 'text-navy underline underline-offset-2 hover:text-crimson font-medium';
export const PRIVACY_EMAIL = 'contact@onlinecollegeguide.io';